import { Text, Stack, Heading, Box, SimpleGrid } from "@chakra-ui/react";
import { FC } from "react";
import * as React from "react";

import CustomWrapper from "components/Chakra/CustomWrapper";
import CustomLink from "components/Chakra/CustomLink";
import ListingPreview from "components/ListingPreview";
import { FindData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";

interface ListingsPromoProps {
  title: string;
  subTitle?: string;
  button?: {
    label: string;
    href: string;
  };
  offers: FindData["offers"];
}

const ListingsPromo: FC<ListingsPromoProps> = ({
  title,
  button,
  subTitle,
  offers,
}) => (
  <CustomWrapper
    maxW="1360px"
    mt={{ base: "40px", md: "128px" }}
    position="relative"
  >
    <Box>
      <Stack
        direction={{ base: "column", md: "row" }}
        align={{ base: "flex-start", md: "start" }}
        justify="space-between"
        mb="40px"
        spacing={{ base: 4, md: 0 }}
      >
        <Stack>
          <Heading
            as="h2"
            size="xl"
            color="ud-black-900"
            data-test="listingsPromo.heading"
          >
            {title}
          </Heading>

          {subTitle && (
            <Text
              fontSize="16px"
              display="block"
              lineHeight="20px"
              fontWeight={400}
              textAlign="left"
              color="ud-black-900"
            >
              {subTitle}
            </Text>
          )}
        </Stack>

        {button && (
          <CustomLink
            href={button.href}
            variant="button_outline_gray"
            w="fit-content"
            borderRadius="full"
            trackEventPayload={{
              "dl.eCat": "homepage",
              "dl.eAct": "bttn.clicked",
              "dl.eLab": button.label,
            }}
          >
            {button.label}
          </CustomLink>
        )}
      </Stack>

      <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={5}>
        {offers.map((offer) => (
          <ListingPreview key={offer.id} offer={offer} />
        ))}
      </SimpleGrid>
    </Box>
  </CustomWrapper>
);

export default ListingsPromo;
